import { put, call, take, takeLatest } from 'redux-saga/effects'
import { makeSaga } from './util'

import { postEffect } from './network'
import { types, actions } from '../reducers/signup'
import { actions as authActions } from '../reducers/auth'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * signupEffect (profile) {
  const request = {
    url: 'signup',
    options: {
      body: {
        ...profile
      }
    }
  }
  const chan = yield call(postEffect, request)
  return yield take(chan)
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

/**
 * call(takeLatest, types.SIGNUP_REQUEST, signupFlow)
 */
export function * signupFlow ({ payload }) {
  const result = yield call(signupEffect, payload)
  if (result.error) {
    yield put(actions.signupError(result))
  } else {
    yield put(actions.signupSuccess(result))
    yield put(authActions.loginRequest(payload))
  }
}

export default makeSaga([
  takeLatest(types.SIGNUP_REQUEST, signupFlow)
])
